export const themeNotFoundMessage = '@cld/component-theme: Unable to find theme in the context.' +
  ' Wrap your application with <ThemeProvider theme={generateTheme(…)}>.' +
  ' Or if you are in the tests, use <TestThemeWrapper> instead.';
